export default "__VITE_ASSET__BDmAYtdc__"